/* eslint camelcase: 0 */

import { RoadmapExpertParameter } from '@/typings/api/Roadmap/Experts/Parameters'
import { Model, createMessages } from '@/helpers/Model'


export class RoadmapBaseEventParameterModel extends Model<RoadmapExpertParameter> {
  public static readonly page_title = createMessages({
    create: 'Добавить Параметр',
    edit: 'Редактировать Параметр',
    view: (data: RoadmapExpertParameter) => 'Параметр «{name}»'
      .replace('{name}', data.report_name || '...'),
    list: 'Меры',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
    delete: (data: RoadmapExpertParameter) => 'Удаление Параметра «{name}»'
      .replace('{name}', data.report_name || '...'),
    delete_all: 'Удаление выбранных параметров',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
